import React from 'react';
import styles from './StateDetails.module.scss';
import { Close } from '@material-ui/icons';

const StateDetails = props => {
  const furtherInfoLink = selectedState => (
    <p>
      <span>
        Further information can be found
        <a target={'_blank'} className={styles.stateLink} href={selectedState?.infoLink}>
          here
        </a>
      </span>
    </p>
  );

  return (
    <div>
      {props.selectedState.value ? (
        props.selectedState?.value === 'nsw' ? (
          <div className={styles.stateInfo}>
            <div className={styles.closeButton}>
              <Close
                onClick={() => {
                  props.setStateInfoModalOpen(false);
                  props.setSelectedState('');
                }}
              />
            </div>
            <h5 className={styles.header}>
              <img src={props.selectedState.logo} alt="state logo" />
              NSW licences and authorities:{' '}
            </h5>
            <div className={styles.infoWrap}>
              {props.serviceList.map(s => (
                <>
                  <h6 className={styles.statesParticipants}>{s.displayName}</h6>
                  <div className={'row'}>
                    <div className={'col-md-6 col-12'}>
                      {s.serviceItem.slice(0, 4).map(item => (
                        <ul>
                          <li>{item}</li>
                        </ul>
                      ))}
                    </div>
                    <div className={'col-md-6 col-12'}>
                      {s.serviceItem.slice(4, s.serviceItem.length).map(item => (
                        <ul>
                          <li>{item}</li>
                        </ul>
                      ))}
                    </div>
                  </div>
                </>
              ))}
              <div className={styles.furtherInfo}>{furtherInfoLink(props.selectedState)}</div>
            </div>
          </div>
        ) : (
          <>
            <div className={styles.closeButton}>
              <Close
                onClick={() => {
                  props.setStateInfoModalOpen(false);
                  props.setSelectedState('');
                }}
              />
            </div>
            <div>
              <h5 className={styles.header}>
                <img src={props.selectedState.logo} alt="state logo" />
                {props.selectedState?.initials} licences and authorities:{' '}
              </h5>
              <div className={styles.furtherInfo}>{furtherInfoLink(props.selectedState)}</div>
            </div>
          </>
        )
      ) : null}
    </div>
  );
};

export default StateDetails;
